export default {
  QUOTE: '/send-quote',
  CONTACT: '/send-email',
}
